import React from "react";
import SmallCard from "../../../components/page/SmallCard";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";

function ContasCards({ cards }) {
  return (
    <>
      <SmallCard
        title="Valor total"
        value={Format.formataValor(cards?.valor_total || 0)}
        icon="mdi mdi-cash-multiple"
      />
      <SmallCard
        title="Valor pago"
        value={Format.formataValor(cards?.valor_pago || 0)}
        icon="mdi mdi-cash-check"
      />
      <SmallCard
        title="Valor em aberto"
        value={Format.formataValor(cards?.valor_aberto || 0)}
        icon="mdi mdi-cash-remove"
      />
    </>
  );
}

ContasCards.propTypes = {
  cards: PropTypes.object.isRequired,
};

export default ContasCards;
